import { Component, OnInit, Input,Output, Inject,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { Pedido } from './pedido.model';
import { EstadoPedido } from './estado-pedido.model';
import { SecurityService } from '../security/security.service';
import { BackendService } from '../core/backend.service';
import { HttpHeaders } from '@angular/common/http';
import { Http, RequestOptions, ResponseContentType } from '../../../node_modules/@angular/http';
import { EnvironmentProvider } from '../core/browser-providers';
import { Environment } from '../../environments/enviroment.model';
import { ArchivoService } from '../core/archivo.service';
import { SnackService } from '../shared-services/snack.service';
import { DialogService } from '../shared-components/modals/dialog.service';

@Component({
  selector: 'app-pedido-table',
  templateUrl: './pedido-table.component.html',
  styleUrls: ['./pedido-table.component.scss']
})
export class PedidoTableComponent implements OnInit {
  
  @Input() pedidosList: Pedido[];
  
  @Output() actualizarLista = new EventEmitter<void>();
  


  backendUrl: string;
  public EstadoPedido = new EstadoPedido();
  constructor(
    public router: Router,
    public securityService: SecurityService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private backendService: BackendService,
    private _http: Http,
    private archivoService: ArchivoService,
    @Inject(EnvironmentProvider) env: Environment,
    private snackService: SnackService,
    private dialogService: DialogService
  ) {
    this.matIconRegistry.addSvgIcon(
      'pend_revision_act_doc',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-notification_important.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'pend_aprobacion_email',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-unsubscribe.svg')
    );
    this.backendUrl = env.endpoints.apiBack;
  }

  ngOnInit() {
  }

  actualizarOnLista() { this.actualizarLista.emit(); }

  detallesPedido(id: number) {
    this.snackService.spinner(true);
    this.router.navigate(['/pedidos/detalles', id]);
  }

  async pdf(id: number) {
    this.snackService.spinner(true);
    try {
      await this.archivoService.getArchivo(id).subscribe(data => {
        this.openWindow(data);
        this.removeFile(id);
      });
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);

    }

  }

  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: data.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    } catch (ex) {
      console.log(ex);
    }
  }

  removeFile(id: number) {
    this.backendService.delete(Pedido.path + 'eliminar-pdf/' + id);
  }

  async confirmEliminar(id: number) {
    this.dialogService.confirm('Eliminar Pedido',
    '¿Está seguro que desea eliminar este pedido?')
    .then( res => {
      if (res) {
        this.deletePedido(res, id);
      }
    });
  }

  async deletePedido(res, id) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Pedido.path + 'eliminar/' + id);
        this.snackService.success('Pedido eliminado correctamente');
        this.router.navigate(['/pedidos']);
        this.actualizarOnLista();
        
    
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/pedido-table.component.ts